 <div class="ui checkbox" [class.slider]="isSlider" >
   <input type="checkbox"
          name="suicheckbox"
          [(ngModel)]="inputValue"
          (click)="$event.stopPropagation()"
          (change)="onChange($event)">
   <label>{{labelName}}</label>
</div>
